
// Separator that adds an extra border to the bottom of each category
export const CategorySeparator = () => {
  return (
    <hr className="category-separator" />
  );
};
